import { IApplicationState, TBoardId } from '../../../../types/types';
import { getBoard } from '../../selectors/getBoardById';

export const getBoardWarning = (
    state: IApplicationState,
    boardId: TBoardId): string => {
    const board = getBoard(state, boardId);
    return board.meta && board.meta.warnings && board.meta.warnings[0];
};
